var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card-title',{staticClass:"headline primary--text"},[_vm._v("Ops...")]),_c('v-card-text',{staticClass:"text-subtitle-1"},[_vm._v(" Nenhum "+_vm._s(_vm.propText)+" encontrado. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }